function switchImage(productId, imageSrc, sectionId, varantUrl) {
  $('#media-' + productId + ' img+img').attr('src', imageSrc);
  $(`#CardLink-${ sectionId }-${ productId }`).attr('href', varantUrl);
  // console.log(`${productId} switch product's img: ${imageSrc}`);
}

function openTab(event, tabName) {
  $('.tabcontent').hide();
  $('.tablinks').removeClass('active');
  $(`.tabcontent.${tabName}`).show();
  var tabButton = event.currentTarget || event.target;
  $(tabButton).addClass('active');
  if (tabButton && typeof tabButton.blur === 'function') {
    tabButton.blur();
  }
}

function showMoreImages() {
  $('.product__media-wrapper').addClass('show-all');
  $('.product__media-show-more').hide();
}

function addFreeMonogram() {
  $('.btn-add-monogram').hide();
  $('.btn-add-monogram.remove').show();
  $('.product-form__buttons .inject').show(200);
  $('.monogram-image-container').show(200);
}

function removeFreeMonogram() {
  // refresh page to remove monogram
  location.reload();
}

function zhGetVariantListJsonEl() {
  return document.querySelector(
    'variant-radios script[type="application/json"]:not([data-selected-variant]), variant-selects script[type="application/json"]:not([data-selected-variant])'
  );
}

function zhParseVariantList() {
  const jsonEl = zhGetVariantListJsonEl();
  if (!jsonEl) return null;
  try {
    return JSON.parse(jsonEl.textContent);
  } catch (e) {
    return null;
  }
}

function zhGetVariantIdInput() {
  return (
    document.querySelector('product-info input.product-variant-id[name="id"]') ||
    document.querySelector('product-info input[name="id"]') ||
    document.querySelector('form[action*="/cart/add"] input[name="id"]')
  );
}

function zhGetVariantFromInput(variants) {
  const idInput = zhGetVariantIdInput();
  if (!idInput || !variants?.length) return null;
  const vid = String(idInput.value).trim();
  if (!vid) return null;
  return variants.find((v) => String(v.id) === vid);
}

function zhGetVariantFromPicker(variants) {
  const root = document.querySelector('variant-radios, variant-selects');
  if (!root || !variants?.length) return null;

  const selected = [];
  root.querySelectorAll('fieldset input:checked').forEach((input) => {
    selected.push(input.value);
  });

  if (!selected.length) {
    root.querySelectorAll('select').forEach((select) => {
      if (select.selectedOptions[0]) selected.push(select.selectedOptions[0].value);
    });
  }

  if (!selected.length) return null;

  return variants.find((v) => {
    return (
      (selected[0] == null || v.option1 === selected[0]) &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    );
  });
}

function zhApplyVariantGalleryVisibility(variants, variantOverride) {
  if (!variants || !variants.length) return;

  const variant =
    variantOverride || zhGetVariantFromInput(variants) || zhGetVariantFromPicker(variants);
  const prefix = variantGalleryColorKey(variant);

  document.querySelectorAll('li.product__media-item').forEach((slide) => {
    const slidePrefix = mediaAltColorKey(slide.getAttribute('data-media-alt') || '');
    const visible = !prefix || slidePrefix === prefix;
    slide.hidden = !visible;
    slide.style.display = visible ? '' : 'none';
    if (!visible) slide.classList.remove('is-active');
  });

  document.querySelectorAll('.thumbnail-list__item[data-target]').forEach((thumb) => {
    const slide = document.querySelector(`[data-media-id="${thumb.dataset.target}"]`);
    const visible = slide && !slide.hidden;
    thumb.hidden = !visible;
    thumb.style.display = visible ? '' : 'none';
  });

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const firstVisible = gallery.querySelector('li.product__media-item:not([hidden])');
    if (firstVisible?.dataset?.mediaId) {
      gallery.setActiveMedia(firstVisible.dataset.mediaId, true);
    }
  });
}

function zhRunVariantGalleryFromDom(variantOverride) {
  const variants = zhParseVariantList();
  if (!variants) return;
  zhApplyVariantGalleryVisibility(variants, variantOverride);
}

function zhInitVariantGallery() {
  if (!zhGetVariantListJsonEl()) return;

  zhRunVariantGalleryFromDom();

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variants = zhParseVariantList();
    if (variants) zhApplyVariantGalleryVisibility(variants, event?.data?.variant);
    zhUpdateSelectedOptionLabel(event);
  });

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    const target = event?.data?.target;
    if (!target?.closest?.('variant-radios, variant-selects')) return;
    zhRunVariantGalleryFromDom();
    zhUpdateSelectedOptionLabel(event);
  });
}

function zhActivateProductSpecUnit(root, unit) {
  if (!root || !unit) return;
  root.querySelectorAll('[data-product-spec-unit]').forEach(function (btn) {
    var active = btn.getAttribute('data-product-spec-unit') === unit;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-product-spec-unit-value]').forEach(function (el) {
    var active = el.getAttribute('data-product-spec-unit-value') === unit;
    if (active) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  });
}

function zhInitProductSpecUnits() {
  document.querySelectorAll('[data-product-specs-init]').forEach(function (root) {
    var activeBtn = root.querySelector('[data-product-spec-unit].is-active');
    if (activeBtn) {
      zhActivateProductSpecUnit(root, activeBtn.getAttribute('data-product-spec-unit'));
    }
  });
}

document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-product-spec-unit]');
  if (!btn) return;
  var root = btn.closest('[data-product-specs-init]');
  if (!root) return;
  event.preventDefault();
  zhActivateProductSpecUnit(root, btn.getAttribute('data-product-spec-unit'));
  if (typeof btn.blur === 'function') {
    btn.blur();
  }
});

function zhUpdateSelectedOptionLabel(event) {
  const variant = event?.data?.variant;
  const sectionId = event?.data?.sectionId;
  if (variant?.option1 && sectionId) {
    const label = document.querySelector(`#variant-radios-${sectionId} .selected__option`);
    if (label) label.textContent = variant.option1;
    return;
  }

  const target = event?.data?.target;
  const sectionRoot = target?.closest?.('variant-radios');
  if (!sectionRoot || target?.type !== 'radio') return;
  const label = sectionRoot.querySelector('.selected__option');
  if (label && target.value) label.textContent = target.value;
}

document.addEventListener('DOMContentLoaded', function () {
  zhInitProductSpecUnits();
  zhInitVariantGallery();
});

$(function () {
  zhInitProductSpecUnits();
});

